import React from 'react'
import {Form, Button, Message, Modal, Image, Confirm, Select} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import MemberSelection from '../memberselection'

const {Field} = Form
const modalStyle = { marginTop: '5%', marginLeft: 'auto', marginRight: 'auto'}
const confirmStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
}

class TemplateEdit extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      title: props.template.name,
      template: Object.assign({}, props.template),
      openConfirm: false,
      postSuccess: false,
      error: undefined,
      isLoading: false
    }
  }
  componentWillUpdate (nextProps) {
    if (this.props.template !== nextProps.template) {
      this.setState({template: Object.assign({}, nextProps.template)})
    }
  }
  showConfirm () {
    this.setState({openConfirm: true})
  }
  handleCancel () {
    this.setState({openConfirm: false})
  }
  handleConfirm () {
    const api = createAPIClient()
    api.delete(`/api/templates/${this.state.template.id}`)
      .then(response => {
        this.setState({openConfirm: false})
        this.props.finishTemplateEditing(true)
      })
      .catch(error => {
        console.log(error)
      })
  }
  cancelEdit () {
    this.props.finishTemplateEditing(false)
  }
  onFieldChange (e) {
    const template = this.state.template
    template[e.target.name] = e.target.value
    this.setState({template: template})
  }
  onDropdownChange (e, {value}) {
    const template = this.state.template
    template['cover_field'] = value
    this.setState({template: template})
  }
  onDuplicate () {
    this.setState({isLoading: true})
    const api = createAPIClient()
    api.post('/api/private/frontend/copy-template', {templateId: this.state.template.id})
      .then(response => {
        this.setState({isLoading: false, postSuccess: false, error: undefined})

        this.props.finishTemplateEditing(true)
      })
  }
  onEditFormSubmit () {
    // call the api
    this.setState({isLoading: true})
    const api = createAPIClient()
    const form = {
      name: this.state.template.name,
      assignee: this.state.template.assignee,
      cover_field: this.state.template.cover_field
    }
    api.put(`/api/templates/${this.state.template.id}`, form)
      .then(response => {
        this.props.finishTemplateEditing(true)
        this.setState({isLoading: false, postSuccess: false, error: undefined})
      })
      .catch(error => {
        console.log(error)
      })
  }
  render () {
    // [{ key: 'af', value: 'af', flag: 'af', text: 'Afghanistan' }, ...{}]

    console.log(this.props.customFields)
    var dropDownCustomFields = this.props.customFields.map(customfield => {
      return {
        key: customfield.id,
        value: customfield.id,
        text: customfield.name
      }
    })
    const editForm = (
      <div>
        <Form id='editForm' loading={this.state.isLoading} onSubmit={this.onEditFormSubmit.bind(this)}>
          {this.state.postSuccess ? (<Message positive>
            <Message.Header>Successfully update team member</Message.Header>
          </Message>) : undefined}

          {this.state.error ? (<Message negative>
            <Message.Header>{this.props.editForm.errorMessage}</Message.Header>
          </Message>) : undefined}
          <Field>
            <label htmlFor='name'>Name</label>
            <input autoFocus type='text' id='name' name='name' value={this.state.template.name}
              onChange={this.onFieldChange.bind(this)} required />
          </Field>
          <Field>
            <label htmlFor='cover'>Cover field</label>
            <Select value={this.state.template.cover_field} placeholder='Select your cover field' options={dropDownCustomFields} onChange={this.onDropdownChange.bind(this)} />
          </Field>
          {/*<MemberSelection*/}
            {/*onFieldChange={this.onFieldChange.bind(this)}*/}
            {/*selected={this.state.template.assignee}*/}
          {/*/>*/}
        </Form>
      </div>
    )
    const modal = (
      <Modal open={this.props.showEditForm} style={modalStyle} onClose={this.cancelEdit.bind(this)}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Edit Form
          <a href='#'>
            <Image onClick={this.cancelEdit.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}} avatar src={'/icons/close_432859.svg'} />
          </a>
          <a href='#'>
            <Image onClick={this.showConfirm.bind(this)} style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px', marginRight: '20px'}} avatar src={'/icons/delete_1397562.svg'} />
          </a>
          <Confirm
            style={confirmStyle}
            open={this.state.openConfirm}
            onCancel={this.handleCancel.bind(this)}
            onConfirm={this.handleConfirm.bind(this)}
            content='Are you sure you want to delete this issue?'
            confirmButton='Yes'
          />
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {editForm}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button content='Duplicate form' onClick={this.onDuplicate.bind(this)} />
          <Button primary icon='check' content='Update' type='submit' form='editForm' />
        </Modal.Actions>
      </Modal>
    )
    return modal
  }
}

export default TemplateEdit



// WEBPACK FOOTER //
// ./src/pages/settings/templates/components/edit/index.js